<div class="scrollable-component">
	<div class="container">
		<div class="row">
			<div class="col-12">
				<p-toast></p-toast>
				<p-panel [header]="label">
					<div class="form-group row">
						<label class="col-sm-6 col-form-label">Default ClassValuation Organization (The Incoming order will be created on behalf this class organization)</label>
						<div class="col-sm-6">
							<p-autoComplete
								[(ngModel)]="selectedOrganization"
								[dropdown]="true"
								[suggestions]="organizations"
								(completeMethod)="filterOrganizations($event)"
								field="name"
								[size]="350"
								(onSelect)="onOrganizationSelect($event)"
							>
							</p-autoComplete>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12 text-right">
							<p-button label="Save" (onClick)="onSave()"></p-button>
						</div>
					</div>
				</p-panel>
			</div>
		</div>
	</div>
</div>
